<template>
            <div class="editor mr-10">
                <div class="topnav">
                    <img src="/images/topnav.png" />
                </div>
                <div class="editor-body">
                    <div class="message-box">
                        <div class="message-title">
                            <textarea v-model="itemData.text"
                                      placeholder="텍스트를 입력하세요."
                                      @keydown="resizeBox($event.target)"
                                      @keyup="resizeBox($event.target)"
                                      @focus="$emit('click:clear')"
                            />
                        </div>
                        <div class="user">
                            <img src="/images/icon_user.png" />
                            <span class="username">김ㅇㅇ</span>
                            <span class="time">18:00</span>
                        </div>
                        <div class="message">
                            <textarea v-model="itemData.message"
                                      placeholder="텍스트를 입력하세요."
                                      @keydown="resizeBox($event.target)"
                                      @keyup="resizeBox($event.target)"
                                      @focus="$emit('click:clear')"
                            />
                        </div>
                    </div>

                    <div class="items">
                        <div class="item" v-for="(answer, index) in itemData.item_answers">
                            <textarea v-model="answer.text"
                                      placeholder="텍스트를 입력하세요."
                                      @keydown="resizeBox($event.target)"
                                      @keyup="resizeBox($event.target)"
                                      @focus="typeForm(answer)"
                            />
                            <div class="btn-send">전송</div>

                        </div>

                    </div>

                </div>
            </div>
</template>

<script>
export default {
	components: {
    },
	data() {
		return {
			form: '',
            color: '#efefef',
            itemData: {
	            text_decorations: {background: '', color: ''},
            },
			currentItem: {},
        }
    },

    props: [
    	'item'
    ],

    watch: {
		item(val) {
			if (val) {
				if (val.text_decorations && typeof val.text_decorations === 'string') {
					val.text_decorations = JSON.parse(val.text_decorations)
				} else {
					val.text_decorations = { background: '', color: ''}
				}

				if (!val.item_answers || val.item_answers.length === 0) {
					val.item_answers = [
                        {text: ''},
						{text: ''},
					]
				}
				this.itemData = val

				setTimeout(_ => {
					$('textarea').each((idx, el)=> {
						this.resizeBox(el)
					})
				})
			}
		}
    },

	mounted() {
		if (this.item) {
			if (this.item.text_decorations && typeof this.item.text_decorations === 'string') {
				this.item.text_decorations = JSON.parse(this.item.text_decorations)
			} else {
				this.item.text_decorations = { background: '', color: ''}
			}

			if (!this.item.item_answers || this.item.item_answers.length === 0) {
				this.item.item_answers = [
					{text: ''},
					{text: ''},
				]
			}
			this.itemData = this.item

			setTimeout(_ => {
				$('textarea').each((idx, el)=> {
					this.resizeBox(el)
				})
			})

		}
	},

	methods: {
		resizeBox(el) {
			el.style.scrollTop = 0
			el.style.height = 'auto'
			el.style.height = (el.scrollHeight) + 'px'
		},
		backgroundForm() {
	        this.$emit('click:background')
        },
		typeForm(itemData) {
            this.$emit('click:type', itemData)
        },
        addItem(index) {
			this.itemData.item_answers.splice(index + 1, 0, { image: ''})
        },
        confirmDelete(index) {
			this.$store.commit('showDialog', {
				type: 'confirm',
                message: '선택지를 삭제하시겠습니까?',
                okCb: _ => {
	                this.itemData.item_answers.splice(index, 1)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.editor {
    width: 360px;
    height: 640px;
    border: 1px solid #ccc;
    position: relative;

    .spliter, .left, .right {
        pointer-events: none;
    }

    .topnav {
        width: 100%;
        opacity: 0.5;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 50;

        img {
            max-width: 100%;
        }
    }

    .editor-body {
        width: 100%; height: 100%;
        overflow: hidden;
        background: #f2f3f7;

        .message-box {
            position: absolute;
            top: 124px;
            width: 100%;

            .message-title {
                font-size: 16px;;
                font-weight: 500;
                padding-left: 41px;
                padding-right: 77px;
                textarea {
                    color: #2f2f2f;
                }
            }

            .user {
                margin-left: 27px;
                display: inline-flex;
                align-items: center;
                margin-top: 29px;

                img {
                    width: 34.5px;
                    height: 34.5px;
                }

                .username {
                    margin-left: 9px;
                    margin-right: 3.5px;
                    font-size: 15px;
                    font-weight: 500;
                    color: #2f2f2f;
                }

                .time {
                    font-size: 12px;
                    font-weight: 500;
                    color: #9b9b9b;
                }
            }

            .message {
                width: 312.5px;
                height: 95.5px;
                margin: 0 auto;
                opacity: 0.93;
                border-radius: 67.5px;
                box-shadow: 10px 10px 15px 0 rgba(15, 41, 107, 0.12);
                border: solid 0.5px rgba(255, 255, 255, 0.5);
                background-image: linear-gradient(289deg, #ffffff 96%, #fcfcfd 56%, #f2f3f7 14%);
                padding: 23px 15px 0 33px;

                textarea {
                    font-size: 16px;;
                    font-weight: 500;
                    color: #2f2f2f;
                    line-height: 1.43;
                    overflow-x: hidden;

                }
            }
        }


        textarea {
            width: 100%;
            height: 100%;
            resize: none;
            padding: 2px;
            overflow-y: hidden;
            pointer-events: auto;
            margin: -1px;
            border: 1px dashed rgba(128,128,128,.5);
        }
        textarea:hover, textarea:focus {
            background: rgba(255,255,255,.2);
            border: 1px solid #ccc;
            margin: -1px;
            border-radius: 5px;
        }

        .items {
            position: absolute;
            left: 0; right: 0;
            bottom: 0;
            background-color: #f9cb51;
            padding: 18.5px 19.5px 24.5px 20.5px;
            height: 273px;


            .item {
                width: 100%;
                height: 96px;
                border-radius: 10.5px;
                background-color: #ffffff;
                position: relative;
                padding: 10px 61px 12px 11px;
                margin-bottom: 10px;

                textarea {
                    font-size: 16px;;
                    line-height: 1.43;
                    color: #2f2f2f;
                }

                .btn-send {
                    position: absolute;
                    right: 7.5px;
                    bottom: 7.5px;
                    border-radius: 6px;
                    padding: 3.5px 8.5px 6px 12px;
                    font-size: 15px;
                    font-weight: 600;
                    background-color: #d1d1d1;
                    color: #ffffff;
                }

                &:hover {
                    background-color: #1985fb;

                    textarea {
                        color: #fff;
                    }

                    .btn-send {
                        background-color: #ffffff;
                        color: #1985fb;
                    }
                }
            }
        }
    }
}
</style>
